import { Helmet } from 'react-helmet-async';
import ArrowRight from '../../icons/ArrowRight';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import useLanguagePrefix from '../../LanguagePrefix';
import { useLocation } from 'react-router-dom';

function ToolFixedMenu() {
    const { t } = useTranslation();
    const fixedMenuRef = React.useRef(null);
    const langPrefix = useLanguagePrefix();
    const location = useLocation();

    const tools = [
        { label: t('ADR'), path: `${langPrefix}/adr-calculator/` },
        { label: t('RevPAR'), path: `${langPrefix}/revpar-calculator/` },
        { label: t('Occupancy Rate'), path: `${langPrefix}/occupancy-rate/` },
        { label: t('GOPPAR'), path: `${langPrefix}/goppar-calculator/` },
        { label: t('TrevPAR'), path: `${langPrefix}/trevpar-calculator/` },
        { label: t('TrevPAB'), path: `${langPrefix}/trevpab-calculator/` },
        { label: t('CPOR'), path: `${langPrefix}/cpor-calculator/` },
        { label: t('ALOS'), path: `${langPrefix}/alos-calculator/` },
    ];


    useEffect(() => {
        const menu = fixedMenuRef.current;
        const footer = document.getElementById('main-footer');
        if (!menu || !footer) return;

        const isAbsolute = { current: false };
        let isEnabled = window.innerWidth > 1200;

        const handleScroll = () => {
            if (!isEnabled) return;

            const footerRect = footer.getBoundingClientRect();

            // Compute where the menu's bottom would be if fixed
            const scrollY = window.scrollY || window.pageYOffset;
            const fixedMenuTop = scrollY + 40;
            const fixedMenuBottom = fixedMenuTop + menu.offsetHeight;

            // Compute where the footer's top is relative to document
            const footerTopAbsolute = scrollY + footerRect.top;

            const distance = footerTopAbsolute - fixedMenuBottom;

            if (!isAbsolute.current && distance < 40) {
                // Enter absolute mode
                isAbsolute.current = true;
                menu.style.position = 'absolute';
                menu.style.top = `${footerTopAbsolute - menu.offsetHeight - 40}px`;
                menu.style.bottom = 'auto';
                menu.style.right = '20px';
            } else if (isAbsolute.current && distance >= 40) {
                // Switch back to fixed
                isAbsolute.current = false;
                menu.style.position = 'fixed';
                menu.style.top = '90px';
                menu.style.bottom = 'auto';
                menu.style.right = '20px';
            }
        };

        window.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', handleScroll);
        handleScroll();

        return () => {
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', handleScroll);
        };
    }, []);


    return (
        <div ref={fixedMenuRef} className='fixed-link-menu d-flex align-items-center justify-sm-content-center flex-column gap-3'>
            <h5 >
                {t('More Tools')}
            </h5>
                {tools.map((tool) => (
                    <a
                        key={tool.path}
                        href={tool.path}
                        className={location.pathname === tool.path ? 'active' : ''}
                    >
                        {tool.label}
                    </a>
                ))}
        </div>
    )
}

export default ToolFixedMenu;